import { render, staticRenderFns } from "./VideoLessons.vue?vue&type=template&id=4aad3e70&"
import script from "./VideoLessons.vue?vue&type=script&lang=ts&"
export * from "./VideoLessons.vue?vue&type=script&lang=ts&"
import style0 from "./VideoLessons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports